import './services.css';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {v4 as uuid} from 'uuid';
import { RootState } from '../../../state/store';

interface IService {
  heading: string,
  content: string,
}

const ServicesComponent = () => {
  const phrases = useSelector((state: RootState) => state.phrases.value);
  
  const serviceItems: Array<IService> = [
    {
      heading: phrases[70],
      content: phrases[71],
    },
    {
      heading: phrases[72],
      content: phrases[73],
    },
    {
      heading: phrases[74],
      content: phrases[75],
    },
    {
      heading: phrases[78],
      content: phrases[79],
    },
    {
      heading: phrases[76],
      content: phrases[77],
    },
  ]

  const [services, setServices] = useState<Array<IService>>(serviceItems);

  useEffect(() => {
    document.title = phrases[36];
    window.scrollTo(0, 0);
  }, [phrases]);

  return (
    <div className='services__sections-container'>
      <h1>{phrases[80]}</h1>
      <section className='services__catalog-container d-flex'>
      {
        services && services.map((service: any) => {
          return (
            <div key={uuid()} className='services__service-outter-container d-flex'>
              <div className='services__service-content-container d-flex'>
                <h2>{service.heading}</h2>
                <p>{service.content}</p>
              </div>
            </div>
          );
        })
      }
      </section>
    </div>
  )
}

export default ServicesComponent
